export const constantsTypes = {
  SIDEBAR_VIEW: 'SIDEBAR_VIEW',
  VIEW_MODE: 'VIEW_MODE',
  GET_SERVICE: 'GET_SERVICE',
  CONFIG_DATA1: 'CONFIG_DATA1',
  CONFIG_DATA2: 'CONFIG_DATA2',
  PERSON_SIDEBAR: 'PERSON_SIDEBAR',
}
